import { render, staticRenderFns } from "./GroupExamTable.vue?vue&type=template&id=64c0d008&"
import script from "./GroupExamTable.vue?vue&type=script&lang=ts&"
export * from "./GroupExamTable.vue?vue&type=script&lang=ts&"
import style0 from "./GroupExamTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports